module.exports = __webpack_public_path__ + "static/thnkdev_santa_monica-95f3529e7720f740be2bdc8af3d3c6e1.jpg";